import styled from "styled-components";

const LoginWrapper = styled.div`
  width: 100vw;
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  background-image: url("back.jpg");
  background-size: cover;
  background-position: center;
  font-family: monospace;
  color: #fff;

  .inputlabel {
    color: aliceblue !important;
  }

  form {
    text-align: center;
    width: 35vw;
    padding: 2rem;
    background: rgba(255, 255, 255, 0.1);
    box-shadow: 0 4px 30px rgba(0, 0, 0, 0.3);
    backdrop-filter: blur(5px);
    -webkit-backdrop-filter: blur(10px);
    /* border: 1px solid rgba(255, 255, 255, 0.2); */
    input {
      color: #fff;
    }
  }
`;
export default LoginWrapper;



// WEBPACK FOOTER //
// ./src/Pages/Login/LoginWr.js